/* Nordic Weaving: kurv-skuffens finpudsning. Bygget 8/9-2026.

   1) Bekræftelsen "Lagt i kurven" vises i to sekunder efter en tilføjelse.
   2) Leveringsdatoen BEREGNES og skrives på dansk. Se den lange note i afsnit 2.
   3) Krydssalget flyttes op lige efter varerne, og overskriften rettes.
   4) Leveringslinjen flyttes ned i bundbjælken over Total. Tilføjet 10/9-2026.
*/
(function (w, d) {
  'use strict';

  /* ================= 1. Lagt i kurven ================= */

  var timer = null;

  function visBekraeftelse() {
    /* Skuffen gentegnes ved hver ændring, så elementet skal findes forfra. */
    setTimeout(function () {
      var el = d.querySelector('[data-nw-lagt]');
      if (!el) return;
      el.hidden = false;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var nu = d.querySelector('[data-nw-lagt]');
        if (nu) nu.hidden = true;
      }, 2600);
    }, 500);
  }

  d.documentElement.addEventListener('on:cart:add', visBekraeftelse);
  d.addEventListener('on:cart:add', visBekraeftelse);

  /* ================= 2. Leveringsdatoen =================

     RETTET 10/9-2026, FORDI DEN VAR FORKERT.

     Feltet #WI_deliveryData fyldes af temaets egen main.js, af en funktion der
     hedder præcis hvad den gør: getDayAfterTwoBusinessDays(). Den lægger ALTID
     to hverdage til og kigger ALDRIG på klokken. Torsdag den 10. september kl.
     11.29 skrev den derfor "mandag 14. sep.", selv om vi pakker samme dag ved
     bestilling inden kl. 14 på en hverdag, og varen altså er fremme fredag.

     Værre: produktsiden regnede rigtigt. Kunden fik altså ét løfte på
     produktsiden og et dårligere i kurven, præcis dér hvor hun skal beslutte
     sig. Det er ikke bare en dato der er gal, det er et løfte der forværres
     undervejs.

     Vi RETTER derfor ikke længere formatet på main.js' tal, vi beregner selv
     og overskriver. main.js kalder sin funktion én gang ved indlæsning, og
     vores observer skriver bagefter. retDato() skriver kun når værdien
     faktisk er en anden, så de to kan ikke komme i ring.

     SELVE REGLEN BOR IKKE HER. Den ligger i assets/nw-levering.js, som både
     denne fil og nw-delivery.js på produktsiden kalder. Det er hele pointen:
     to flader der viser samme løfte skal dele koden, ikke bare ligne hinanden.
     Vil du ændre fristen, ugedagene eller lukkedagene, så ret dén fil.

     Mangler window.NWLev, gør vi ingenting og lader teksten stå. Så er den
     ganske vist main.js' forkerte dato, men et tomt felt ville være værre.
     nw-levering.js indlæses før denne fil fra doc-head-core. */

  function retDato() {
    var el = d.getElementById('WI_deliveryData');
    if (!el || !w.NWLev) return;
    var ny = w.NWLev.beregn().tekst;
    if (el.textContent !== ny) el.textContent = ny;
  }

  /* ---------- 2b. Samme dato på KURVSIDEN, tilføjet 10/9-2026 ----------

     Målt: #WI_deliveryData findes slet ikke på /cart. Leverings-appen skriver
     kun i skuffen. Kurvsiden havde derfor kun det generelle løfte "Bestil
     inden kl. 14 på hverdage, så sender vi samme dag", altså en regel kunden
     selv skal regne på, dér hvor hun skal beslutte sig.

     Løftet fandtes i tre detaljeringsgrader: produktsiden skrev ugedagen,
     skuffen skrev dato, kurvsiden skrev ingenting. Nu skriver alle tre den
     samme dato fra den samme beregning i nw-levering.js.

     Den statiske sætning bliver stående i Liquid som reserve. Er NWLev ikke
     indlæst, står den generelle regel der stadig. Et tomt felt hvor der
     skulle stå en leveringsdato er værre end en upræcis sætning. */
  function retDatoKurvside() {
    var boks = d.querySelector('#cartform .nwcp-lev');
    var el = boks && boks.querySelector('div');
    if (!el || !w.NWLev) return;
    var r = w.NWLev.beregn();
    var ny = r.kanPakkesIDag
      ? 'Bestil inden kl. 14, s&aring; er den fremme <b>' + r.tekst + '</b>'
      : 'Forventet levering <b>' + r.tekst + '</b>';
    if (el.innerHTML !== ny) el.innerHTML = ny;
  }

  /* ================= 3. Krydssalget på plads ================= */

  /* Temaet lægger krydssalget som SØSKENDE til indholdsblokken, altså efter
     fragt og levering. Mockuppen har det lige efter varerne, hvor kunden
     stadig kigger. Vi flytter noden frem for at bygge Liquid'en om: temaets
     ajax-fletning matcher på attributten data-merge og ikke på position,
     så en flytning er ufarlig for opdateringen.

     Selve udvalget er rettet i Liquid: data-from har nu intent=complementary,
     så listen kommer fra metafeltet complementary_products i stedet for
     Shopifys "related", som foreslog ANDRE sengetøjssæt til en kunde der
     lige havde valgt sit. Den absolut placerede dublet skjules i CSS. */
  /* KRITISK, fundet 8/9 om aftenen: denne funktion og nw-gem.js sloges om
     rækkefølgen og flyttede de samme to blokke frem og tilbage cirka fem
     gange i sekundet. Skuffen stod og hoppede synligt for kunden.

     Rodårsagen var at begge sider havde en absolut mening om placeringen:
     denne ville have krydssalget lige før .cart-drawer__summary, og nw-gem.js
     ville have de gemte varer lige efter krydssalget. Når nw-gem.js skød sin
     boks ind imellem, var betingelsen her ikke længere opfyldt, og så blev
     krydssalget flyttet tilbage, og så videre i ring.

     Løsningen er at de to bliver enige om ÉN rækkefølge: varer, krydssalg,
     gemt til senere, opsummering. Er boksen med de gemte varer til stede,
     er det den krydssalget skal ligge foran, ikke opsummeringen. Så er begge
     betingelser opfyldt samtidig, og der er ikke noget at slås om.

     LÆRE: to uafhængige MutationObservere må aldrig hver især have en absolut
     mening om den samme rækkefølge. Én skal give efter for den anden. */
  /* Rækkefølgen i skuffen, revideret 10/9-2026: varer, krydssalg, gemt til
     senere, og til sidst forventet levering, total og betaling i bundbjælken.

     9/9 lå fragt og levering som et sandfarvet kort mellem varerne og
     krydssalget, med den begrundelse at det er kundens mest presserende
     spørgsmål. Målt på telefon var prisen 124 px, og krydssalget blev derfor
     skubbet helt under kanten: Mads så det ikke uden at rulle. Dertil sagde
     kortets første linje, "Fragt: Gratis", præcis det samme som bjælken
     øverst i skuffen, "Du har fri fragt. Vi sender med GLS til pakkeshop."
     To gange samme løfte, betalt med en halv skærm.

     Krydssalget lægges stadig EFTER .cart-drawer__summary. Elementet bliver
     stående i DOM'en selv når det er tomt og skjult, netop så denne funktion
     og nw-gem.js har det samme faste anker som før. Se nw-gem2.css. */
  function flytKrydssalg() {
    var boks = d.querySelector('[data-merge="cross-sells"]');
    var sum  = d.querySelector('.cart-drawer__summary');
    if (!boks || !sum || !sum.parentNode) return;
    if (boks.previousElementSibling === sum) return;   // står allerede rigtigt
    sum.parentNode.insertBefore(boks, sum.nextSibling);
  }

  /* Overskriften kommer fra en temaindstilling og hedder "Måske noget for dig?".
     Den er upræcis nu, hvor listen kun rummer tilbehør der passer.

     FÆLDE: underteksten må IKKE indsættes ved siden af overskriften, for den
     ligger i .opposing-items, som er en flex-række. Der lagde den sig ved
     siden af i stedet for under. Den skal efter hele rækken. */
  function retOverskrift() {
    d.querySelectorAll('[data-merge="cross-sells"] .product-info-label').forEach(function (el) {
      if (el.getAttribute('data-nw-titel')) return;
      el.setAttribute('data-nw-titel', '1');
      el.textContent = 'Gør sættet færdigt';

      var raekke = el.closest('.opposing-items') || el;
      if (!raekke.parentNode) return;
      if (raekke.nextElementSibling && raekke.nextElementSibling.classList.contains('nw-xs-sub')) return;

      var sub = d.createElement('p');
      sub.className = 'nw-xs-sub';
      sub.textContent = 'Passer til det du allerede har valgt';
      raekke.parentNode.insertBefore(sub, raekke.nextSibling);
    });
  }

  /* ================= 3c. Tom kurv: kategorierne bliver til rækker =========
     Tilføjet 10/9-2026.

     Liquid skriver fire nøgne links, ét ord hver: Sengetøj, Dyner, Lagner,
     Cashmere. Som piller var de fire kasser i en flade der i forvejen er en
     kasse, og ét ord er en fattig grund til at klikke. Her får hver kategori
     en underlinje med hvad der FAKTISK ligger i kollektionen.

     TEKSTERNE ER HENTET FRA KATALOGET 10/9-2026, ikke skrevet efter
     hukommelse. Optalt på productType i hver kollektion:
       sengetoj  50 varer: bambus, egyptisk bomuld, hør, silke
       dyner     19 varer: dun, edderdun, moskusdun, bambus, silke, køledyne
       lagner    82 varer: bambus, silke, egyptisk bomuld
       cashmere 107 varer: bluser, cardigans, huer, halstørklæder, veste
     Cashmere var den vigtige: jeg havde nær skrevet "plaider og tilbehør",
     og der er ikke ét plaid i kollektionen. Ændres sortimentet, skal
     teksterne med.

     HVORFOR JAVASCRIPT OG IKKE LIQUID. Markup'en står to steder,
     sections/main-cart.liquid (23 KB) og sections/cart-drawer.liquid (37 KB),
     og en themeFilesUpsert er en fuld overskrivning uden versionshistorik.
     At skrive 60 KB Liquid om for at tilføje fire sætninger er en større
     risiko end gevinsten. Selve Gemt til senere-boksen lige under er i
     forvejen ren JavaScript, så den tomme kurv er allerede en JS-flade.
     Skal sektionerne alligevel redigeres en dag, så flyt teksterne ind i
     Liquid og slet denne funktion.

     Funktionen skal kunne køre igen og igen: MutationObserver'en nedenfor
     ser vores egne ændringer, og temaets ajax gentegner hele varelisten ved
     hver kurvændring. Derfor mærket data-nw-pyntet. */

  var NWTOM_UNDER = {
    '/collections/sengetoj': 'Bambus, egyptisk bomuld, hør og silke',
    '/collections/dyner': 'Dun, bambus og silke, sommer og helår',
    '/collections/lagner': 'Box- og kuvertlagen i bambus, silke og egyptisk bomuld',
    '/collections/cashmere': 'Bluser, cardigans, huer og halstørklæder'
  };

  function pyntTomKurv() {
    var lister = d.querySelectorAll('.nwtom__lk');
    for (var i = 0; i < lister.length; i++) {
      var liste = lister[i];
      if (liste.getAttribute('data-nw-pyntet') === '1') continue;
      liste.setAttribute('data-nw-pyntet', '1');

      /* h3 og ikke span: afsnittet skal være sideordnet med "Gemt til senere"
         lige under, også for en skærmlæser, ikke bare i tykkelsen. */
      if (!liste.querySelector('.nwtom__lbl')) {
        var lbl = d.createElement('h3');
        lbl.className = 'nwtom__lbl';
        lbl.textContent = 'Kig videre her';
        liste.insertBefore(lbl, liste.firstChild);
      }

      var lenker = liste.querySelectorAll('a');
      for (var j = 0; j < lenker.length; j++) {
        var a = lenker[j];
        if (a.querySelector('.nwtom__t')) continue;
        var sti = (a.getAttribute('href') || '').split('?')[0].replace(/\/+$/, '');
        var titel = (a.textContent || '').trim();
        var under = NWTOM_UNDER[sti] || '';
        a.textContent = '';
        var t = d.createElement('span');
        t.className = 'nwtom__t';
        t.textContent = titel;
        a.appendChild(t);
        if (under) {
          var u = d.createElement('span');
          u.className = 'nwtom__d';
          u.textContent = under;
          a.appendChild(u);
        }
      }
    }
  }

  /* ================= 3b. Samlet besparelse, regnet forfra =================

     KRITISK FEJL FUNDET 10/9-2026. Liquid rendrer besparelseslinjen ÉN gang
     ved sideindlæsning og opdaterer den ALDRIG. Målt: kurv med sengetøj og
     boxlagen viste "- 67,35 kr". Jeg tog boxlagen ud igen, totalen faldt til
     649,00 kr og den faktiske rabat blev 0, og linjen stod uændret og lovede
     stadig 67,35 kr. Node-identiteten var den samme før og efter, altså
     gentegnede temaet den slet ikke. Et forkert beløb om penge, lige over
     Gå til betaling.

     Vi regner den derfor selv efter hver kurvændring, med PRÆCIS samme
     definition som Liquid brugte, så tallet ikke skifter betydning:
       linjerabat, hvis final_line_price < original_line_price
       ellers compare_at-besparelse, hvis varen er nedsat
       plus rabatter på kurvniveau

     compare_at_price findes IKKE på varelinjen i /cart.js. Efterprøvet: de
     40 felter rummer price, original_price, final_line_price og
     total_discount, men ingen compare_at. Den hentes derfor fra
     /products/<handle>.js og caches pr. handle. Samme princip som Gem til
     senere, hvor priser også hentes live frem for at stole på et
     øjebliksbillede.

     Er besparelsen 0, skjules linjen helt. Et "Samlet besparelse: 0,00 kr"
     er værre end ingenting. */

  function nwKr(oere) {
    var v = oere / 100;
    return v.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  }

  var prodCache = {};

  function hentProdukt(handle) {
    if (prodCache[handle] !== undefined) return Promise.resolve(prodCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) { prodCache[handle] = p; return p; });
  }

  function beregnBesparelse(kurv) {
    var dele = kurv.items.map(function (it) {
      if (it.final_line_price < it.original_line_price) return Promise.resolve(it.total_discount);
      return hentProdukt(it.handle).then(function (p) {
        if (!p || !p.variants) return 0;
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (v.id === it.variant_id) {
            return (v.compare_at_price && v.compare_at_price > v.price)
              ? (v.compare_at_price - v.price) * it.quantity
              : 0;
          }
        }
        return 0;
      });
    });
    return Promise.all(dele).then(function (tal) {
      var sum = 0;
      tal.forEach(function (n) { sum += n; });
      (kurv.cart_level_discount_applications || []).forEach(function (dd) {
        sum += dd.total_allocated_amount || 0;
      });
      return sum;
    });
  }

  var sparTravl = false;

  /* IKKE LÆNGERE KUN SKUFFEN, rettet 10/9-2026. Kurvsiden manglede linjen
     helt, og viste i stedet "Varer 998,00 kr" oven over "Total: 998,00 kr",
     altså det samme tal to gange. Værre: Varer-linjen viste summen EFTER
     rabat, så de 350 kr kunden faktisk sparede var usynlige på hele siden.
     Vi viste tre linjer hvoraf de to var ens, og udelod den ene der ville
     have gjort kunden glad.

     Begge flader bruger nu klassen .nw-spar og det samme regnestykke, så
     tallet ikke kan nå at betyde to forskellige ting. Alle forekomster
     opdateres, ikke bare den første: er skuffen bygget mens kunden står på
     kurvsiden, findes linjen to steder i dokumentet samtidig. */
  function sparRaekker() {
    return d.querySelectorAll('.nw-spar');
  }

  function retBesparelse() {
    if (sparTravl || !sparRaekker().length) return;
    sparTravl = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(beregnBesparelse)
      .then(function (sum) {
        sparTravl = false;
        var ny = '- ' + nwKr(sum);
        sparRaekker().forEach(function (raekke) {
          if (sum > 0) {
            raekke.hidden = false;
            var v = raekke.querySelector('[data-nw-spar-val]');
            if (v && v.textContent !== ny) v.textContent = ny;
          } else {
            raekke.hidden = true;
          }
        });
      })
      .catch(function () { sparTravl = false; });
  }

  /* ================= 4. Leveringslinjen ned i bundbjælken =================

     Beslutning 10/9-2026: leveringsdatoen er den ENESTE oplysning i kortet der
     ikke står andre steder i skuffen, og den hører hjemme dér hvor kunden
     beslutter sig, altså lige over Total og Gå til betaling. Fragt-linjen
     fjernes helt, den gentog fri fragt-bjælken øverst.

     HVORFOR JS OG IKKE LIQUID: sections/cart-drawer.liquid fylder 36 KB, og en
     upsert er en fuld overskrivning uden versionshistorik. At genskrive hele
     filen for at flytte to linjer er en større risiko end at flytte noden.
     nw-kurv.js flytter i forvejen hele krydssalget på samme måde, og skuffen
     er lukket når flytningen sker, så der er intet at se.

     PLACERES UDEN FOR [data-merge="footer"]. Den blok gentegnes ved hver
     kurvændring, og leverings-appen skriver først sin dato ind EFTER render.
     Lå linjen indeni, ville datoen falde tilbage til "Beregner..." hver gang
     kunden trykkede plus. Datoen afhænger i forvejen ikke af kurvens indhold,
     kun af afsendelsesfristen, så en statisk node er også det korrekte.

     Gentegner temaet alligevel opsummeringen og laver en NY node med samme
     id, fjernes vores kopi i bundbjælken. To elementer med samme id ville
     ellers få retDato() til at formatere den forkerte. */
  function flytLevering() {
    var foot = d.querySelector('cart-drawer .cart-drawer__footer');
    /* .nw-inkl findes kun når settings.nw_ny_kurv er slået til. Det er den
       billigste måde at spørge Liquid om en indstilling fra JS. */
    if (!foot || !foot.querySelector('.nw-inkl')) return;

    var maal = foot.querySelector('[data-merge="footer"]');
    if (!maal) return;

    var raekker = d.querySelectorAll('cart-drawer .cart-shipping-label');
    var min = null;
    for (var i = 0; i < raekker.length; i++) {
      if (!raekker[i].querySelector('[id="WI_deliveryData"]')) continue;
      if (min) { raekker[i].remove(); continue; }   // dublet efter gentegning
      min = raekker[i];
    }
    if (min) {
      min.classList.add('nw-lev');
      if (min.parentNode !== foot) foot.insertBefore(min, maal);
    }

    /* Besparelseslinjen bygger vi selv, i stedet for at flytte temaets.
       Temaets ligger i .cart-drawer__summary, som er skjult i den nye kurv,
       og dens tal er som bekendt forældet. Se afsnit 3b. Rækkefølgen i
       bundbjælken bliver: forventet levering, samlet besparelse, Total.
       Besparelsen står tættest på Total, fordi de begge handler om penge. */
    var spar = foot.querySelector('.nw-spar');
    if (!spar) {
      spar = d.createElement('div');
      spar.className = 'nw-spar';
      spar.hidden = true;
      spar.innerHTML = '<span>Samlet besparelse:</span><span data-nw-spar-val></span>';
      foot.insertBefore(spar, maal);
      retBesparelse();
    } else if (spar.parentNode !== foot || spar.nextElementSibling !== maal) {
      foot.insertBefore(spar, maal);
    }
  }

  /* ================= 4b. Besparelseslinjen ind i kurvsidens panel =========
     Tilføjet 10/9-2026.

     Panelet på /cart havde tre linjer om penge: "Varer 998,00 kr",
     "Fragt Gratis" og "Total: 998,00 kr". To af dem var det samme tal, og
     fragt-linjen sagde præcis det samme som sandkortet øverst på siden, "Du
     har fri fragt. Vi sender med GLS til pakkeshop." Begge er nu skjult i
     nw-cart-page.css, og her sætter vi den linje ind der manglede.

     HVORFOR JS OG IKKE LIQUID, samme begrundelse som i afsnit 4:
     sections/main-cart.liquid fylder 23 KB, og en upsert er en fuld
     overskrivning uden versionshistorik. At skrive hele filen om for at
     bytte to linjer ud er en større risiko end at skyde en node ind. NÅR
     sektionen alligevel skal redigeres næste gang, så slet de to .nwcp-sl
     linjer i Liquid og fjern skjule-reglen i CSS'en. De står som død markup
     indtil da, og det er noteret i CSS-filen.

     PLACERING: lige før h2.subtotal, altså tættest på Total. De to hører
     sammen, det er de eneste to tal kunden skal sammenligne.

     Blokken ligger inde i [data-merge="total"], som temaet gentegner ved
     hver antalsændring. Vores node ryger derfor med, og koer() sætter den
     ind igen. Den kommer tilbage SKJULT, og retBesparelse() fylder den
     først når /cart.js har svaret. Det er med vilje: et forældet beløb om
     penge er værre end en linje der mangler i 400 ms. Det var netop den
     fejl vi fandt i skuffen samme dag. */
  function byggSparKurvside() {
    var total = d.querySelector('#cartform .subtotal');
    if (!total || !total.parentNode) return;
    if (total.parentNode.querySelector('.nw-spar')) return;

    var spar = d.createElement('div');
    spar.className = 'nwcp-sl nwcp-sl--spar nw-spar';
    spar.hidden = true;
    spar.innerHTML = '<span>Samlet besparelse</span><b data-nw-spar-val></b>';
    total.parentNode.insertBefore(spar, total);
  }

  /* ================= 5. Kurvsiden gentegner ikke sig selv =================

     Målt 9/9: krydssalgets køb-knap på KURVSIDEN kalder /cart/add.js og
     udsender derefter dispatch:cart-drawer:refresh. Det event tilhører
     skuffen. På kurvsiden findes ingen skuffe, så INTET gentegnede: varen lå
     i kurven på serveren, men rækken kom først ved en manuel genindlæsning,
     og knappen blev stående i sin is-loading-tilstand.

     Temaet har ingen krog til at gentegne kurvsiden, så vi genindlæser den.
     Samme løsning som nw-gem.js allerede bruger efter Læg i kurv.

     VIGTIGT om hvilke events vi lytter på: en almindelig antalsændring
     udsender on:cart:change, IKKE de to herunder. Det er efterprøvet. Ellers
     ville hvert tryk på plus koste en sideindlæsning. */
  if (/^\/cart/.test(w.location.pathname)) {
    var genindlaesTimer = null;
    var planlaegGenindlaes = function () {
      if (genindlaesTimer) return;
      genindlaesTimer = setTimeout(function () { w.location.reload(); }, 300);
    };
    ['dispatch:cart-drawer:refresh', 'on:cart:add'].forEach(function (t) {
      d.addEventListener(t, planlaegGenindlaes);
      d.documentElement.addEventListener(t, planlaegGenindlaes);
    });
  }

  /* ================= 6. Skuffen må ikke falde sammen mens temaet gentegner
     Tilføjet 11/9-2026, meldt af Mads med video og skærmbillede fra iPhone.

     SYMPTOMET: man trykker Tilføj på et komplementærprodukt, hele skuffen
     hopper, og "Gem til senere" fra varelinjen lander midt inde i den
     sandfarvede "Gør sættet færdigt".

     MÅLT, samplet hver 40 ms på 375 x 812 fra klik til ro:
       0 til 1060 ms   intet sker overhovedet, temaet venter på /cart/add.js
       1264 ms         varelisten rummer pludselig TRE varer, hvor der skulle
                       være to. Temaet indsætter den nye markup før den gamle
                       er fjernet
       1477 ms         .cart-item-list er 0 px høj, mens krydssalget allerede
                       er tegnet igen. Overlappet er 165 px
       2150 ms         alt er på plads igen
     Altså cirka 700 ms hvor layoutet er i stykker, og 2,3 sekunder i alt.
     Mads' skærmbillede er et videobillede fra netop det vindue, og det
     forklarer hvorfor totalen på billedet stadig stod på én vare.

     RETTELSEN: lås varelistens højde og klip dens indhold mens temaet
     arbejder. Så kan kassen ikke falde sammen, krydssalget bliver stående, og
     indhold der midlertidigt stikker ud bliver klippet i stedet for tegnet
     oven på næste sektion. Efterprøvet: 0 synlige overlap i 111 målinger, og
     listen kom aldrig under sin starthøjde.

     TRE FÆLDER, alle tre kostede et forsøg:

     1. FRIGIVELSEN MÅ IKKE SE PÅ HØJDEN ALENE. Første udgave slap låsen så
        snart indholdet var højere end 40 px. Men der sker ingenting det
        første sekund, så den slap 120 ms efter klikket, længe før sammenfaldet.
        Nu kræves det at højden FAKTISK har ændret sig siden låsningen, og
        derefter har stået stille i 300 ms.

     2. on:cart:add OG on:cart:change FYRER IKKE her. Efterprøvet med tællere:
        begge stod på 0 efter et klik på krydssalgets Tilføj. Knappen kalder
        /cart/add.js og udsender dispatch:cart-drawer:refresh. Derfor hænger
        låsen på selve KLIKKET, i indfangningsfasen, ikke på kurv-events.

     3. KUN HANDLINGER DER LÆGGER I KURVEN. En lås er kun ufarlig når listen
        bagefter bliver STØRRE. Ved sletning ville en gammel minimumshøjde
        holde kassen for høj i op til fem sekunder. Derfor kun Tilføj i
        krydssalget og Læg i kurv i Gemt til senere.

     DEN EGENTLIGE FEJL ER TEMAETS. Det burde ikke rendre tre varer i en liste
     der skal rumme to. Vi kan ikke rette temaets fletning uden at skrive
     cart-drawer.liquid om, så vi holder kassen stille mens det står på.
     ================================================================= */

  var laasTimer = null, laasT0 = 0, laasStartH = -1, laasSidsteH = -1, laasStabil = 0, laasRykket = false;

  function laasListe() { return d.querySelector('cart-drawer .cart-item-list'); }
  function laasKrop() { return d.querySelector('cart-drawer .cart-item-list__body'); }

  function slipLaas() {
    var l = laasListe();
    if (l) { l.style.minHeight = ''; l.style.overflow = ''; }
    clearInterval(laasTimer);
    laasTimer = null;
  }

  function tjekLaas() {
    var b = laasKrop();
    if (!b) return slipLaas();
    var h = Math.round(b.getBoundingClientRect().height);
    if (h !== laasStartH) laasRykket = true;
    if (laasRykket && h > 40 && h === laasSidsteH) {
      if (!laasStabil) laasStabil = Date.now();
      else if (Date.now() - laasStabil > 300) return slipLaas();
    } else {
      laasStabil = 0;
    }
    laasSidsteH = h;
    /* Nødbremse. Svarer aldrig serveren, slipper låsen alligevel. */
    if (Date.now() - laasT0 > 5000) slipLaas();
  }

  function laasKurvhoejde() {
    var l = laasListe(), b = laasKrop();
    if (!l || !b) return;
    var h = Math.round(l.getBoundingClientRect().height);
    if (h <= 0) return;
    l.style.minHeight = h + 'px';
    l.style.overflow = 'hidden';
    laasT0 = Date.now();
    laasStartH = Math.round(b.getBoundingClientRect().height);
    laasSidsteH = -1;
    laasStabil = 0;
    laasRykket = false;
    if (!laasTimer) laasTimer = setInterval(tjekLaas, 100);
  }

  d.addEventListener('click', function (e) {
    if (e.target && e.target.closest &&
        e.target.closest('cart-drawer .nwxs-add__btn, cart-drawer .nw-gem__add')) {
      laasKurvhoejde();
    }
  }, true);

  /* ================= opsætning ================= */

  /* Besparelsen koster et kald til /cart.js, så den må IKKE ligge i koer(),
     som fyrer ved hver eneste DOM-ændring på siden. Den hænges på de tre
     events der faktisk betyder at kurven har ændret sig. Forsinkelsen på
     400 ms er fordi /cart.js skal nå at afspejle ændringen på serveren. */
  ['on:cart:change', 'on:cart:add', 'dispatch:cart-drawer:refresh'].forEach(function (t) {
    var h = function () { setTimeout(retBesparelse, 400); };
    d.addEventListener(t, h);
    d.documentElement.addEventListener(t, h);
  });

  var planlagt = null;
  function koer() {
    flytLevering();
    byggSparKurvside();
    retDato();
    retDatoKurvside();
    flytKrydssalg();
    retOverskrift();
    pyntTomKurv();
  }
  function planlaeg() {
    if (planlagt) return;
    planlagt = setTimeout(function () { planlagt = null; koer(); }, 80);
  }

  function start() {
    koer();

    /* KURVSIDEN FYRER INGEN KURV-EVENTS VED INDLÆSNING. Skuffen bygges først
       når kunden åbner den, og så kommer der en gentegning der udløser
       besparelsen. På /cart står linjen i siden fra første sekund, og uden
       dette kald ville den blive stående skjult indtil kunden ændrede et
       antal. Målt 10/9. */
    if (d.querySelector('#cartform .nw-spar')) retBesparelse();

    /* Appen skriver datoen ind efter render, krydssalget hentes asynkront,
       og skuffen gentegnes ved hver ændring. */
    try {
      new MutationObserver(planlaeg)
        .observe(d.documentElement, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }

  d.readyState === 'loading' ? d.addEventListener('DOMContentLoaded', start) : start();
})(window, document);
